import PropTypes from 'prop-types';
import { Link, NavLink } from 'react-router-dom';
import EnvironmentBadge from '../../components/layout/EnvironmentBadge';
import PageShell from '../../components/layout/PageShell';
import { ROUTES } from '../../utils/constants';

const workspaceLinks = [
  { label: 'Overview', to: ROUTES.DEV_DASHBOARD, end: true },
  { label: 'Test environments', to: ROUTES.DEV_TEST_ENVIRONMENTS },
];

if (import.meta.env.DEV) {
  workspaceLinks.push({ label: 'Project Control', to: ROUTES.PROJECT_CONTROL });
}

export default function DeveloperWorkspaceShell({ authorized, children, user, onLogout }) {
  if (!authorized) {
    return (
      <div className="min-h-screen bg-base-200">
        <PageShell>{children}</PageShell>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-base-200">
      <header className="border-b border-base-300 bg-base-100">
        <div className="mx-auto flex w-full max-w-7xl flex-wrap items-center gap-4 px-4 py-4 lg:px-6">
          <Link className="mr-auto" to={ROUTES.DEV_DASHBOARD}>
            <span className="block text-xs font-semibold uppercase tracking-[0.18em] text-primary">
              Swan platform
            </span>
            <span className="text-lg font-bold">Developer Workspace</span>
          </Link>

          <nav aria-label="Developer Workspace" className="order-3 flex w-full flex-wrap gap-1 md:order-none md:w-auto">
            {workspaceLinks.map(link => (
              <NavLink
                key={link.to}
                className={({ isActive }) => `btn btn-sm ${isActive ? 'btn-primary' : 'btn-ghost'}`}
                end={link.end}
                to={link.to}
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <EnvironmentBadge />
            <span className="hidden max-w-56 truncate text-sm text-base-content/70 lg:block">
              {user?.email}
            </span>
            <button className="btn btn-ghost btn-sm" onClick={onLogout} type="button">
              Sign out
            </button>
          </div>
        </div>
      </header>

      <PageShell>{children}</PageShell>
    </div>
  );
}

DeveloperWorkspaceShell.propTypes = {
  authorized: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  user: PropTypes.shape({ email: PropTypes.string }),
  onLogout: PropTypes.func.isRequired,
};
